/* eslint-disable max-len */
import { Box, Button, Checkbox, Grid, Stack, Tooltip, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';
import { PiDotsSixVerticalBold } from 'react-icons/pi';
import NewDialogPopup from '../../../../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import { LanguageContext } from '../../../../../../../../../libs/Context';
import AddCustomField from './AddCustomField';

const RegistrationField = (props:any) =>
{
	const { registration, fieldsList, handleSet } = props;
	const { language } = useContext(LanguageContext);
	const fields = fieldsList;
	const [ addField, setAddField ] = useState(false);
	const [ delPopUp, setDelPopUp ] = useState({ open: false, index: -1 });
	const [ dragOverIndex, setDragOverIndex ] = useState<null| number>(null);

	const handleDragStart = (e, index) =>
	{
		e.dataTransfer.setData('dragIndex', index);
	};

	const setRegistrationField = (newFields) =>
	{
		handleSet('registrationFields', newFields);
	};

	const handleDrop = (e, index) =>
	{
		e.preventDefault();
		const dragIndex = e.dataTransfer.getData('dragIndex');

		setDragOverIndex(null); // Reset drag-over index

		if (dragIndex === index || [ 0, 1 ].includes(index)) return;
		const newItems = [ ...fields ];
		const draggedItem = newItems.splice(dragIndex, 1)[0];

		newItems.splice(index, 0, draggedItem);
		newItems.splice(index, 0);
		setRegistrationField(newItems);
	};

	const handleDragOver = (e, index) =>
	{
		e.preventDefault();
		setDragOverIndex(index); // Update drag-over index
	};

	const toggleAddField = () =>
	{
		setAddField(!addField);
	};

	const toggleDelete = (index?) =>
	{
		delPopUp.open
			? setDelPopUp({ open: false, index: -1 })
			: setDelPopUp({ open: !delPopUp.open, index });
	};

	const handleAddField = (obj) =>
	{
		setRegistrationField([ ...fields, obj ]);
	};

	const handleCheckBox = (ind, isRequired) =>
	{
		const tempFields = [ ...fields ];

		tempFields[ind] = { ...tempFields[ind], isRequired };
		// setFields(tempFields);
		setRegistrationField(tempFields);
	};

	const handleDeleteField = () =>
	{
		const tempFields = [ ...fields ];

		tempFields.splice(delPopUp.index, 1);
		setRegistrationField(tempFields);
		toggleDelete();
	};

	return (
		<Grid item xs={12} p='var(--pixel8)'>
			<Typography variant='inherit' fontSize='var(--pixel18)' fontWeight='var(--font500)'>{language?.registrationFileds}</Typography>
			<Typography variant='inherit' py='var(--pixel4)'>{language?.registrationSpecify}</Typography>
			<Stack
				spacing={1}
				direction='column'
				// sx={{ cursor: disableDrag ? 'no-drop' : 'default' }}
				py='var(--pixel8)'
			>
				{(registration ? fields : (fields ?? []).slice(0, 2)).map((field, index) => (
					<Box
						key={`${field?.field}-${index}`}
						alignItems='center'
						display='flex'
						draggable={![ 0, 1 ].includes(index)}
						onDragStart={(e) => handleDragStart(e, index)}
						onDragOver={(e) => handleDragOver(e, index)}
						onDrop={(e) => handleDrop(e, index)}
						sx={{
							border       : dragOverIndex === index ? '2px dashed var(--primaryColor)' : '1px dashed #707070',
							borderRadius : 'var(--pixel8)',
							px           : 'var(--pixel8)',
							my           : 'var(--pixel8)',
							width        : 'var(--percent100)'
						}}
						// className={disableFields && 'disableMode'}
					>
						<Grid container alignItems='center' justifyContent={'space-between'}>
							<Grid item>
								<Stack spacing={1} direction='row' alignItems='center'>
									<Typography variant='inherit' color='textSecondary' display='flex' alignItems='center' sx={{ cursor: 'move' }}>
										<PiDotsSixVerticalBold fontSize='var(--pixel24)' />
									</Typography>
									<Typography variant='inherit'>{field.field}</Typography>
								</Stack>
							</Grid>
							<Grid item>
								<Stack spacing={1} direction='row' alignItems='center'>
									<Typography variant='inherit' color='textSecondary'>
										<Checkbox
											checked={field.isRequired}
											onChange={(e, checked) => handleCheckBox(index, checked)}
											sx={{
												color         : 'var(--primaryColor)',
												opacity       : index === 0 || index === 1 ? 0.5 : 1,
												pointerEvents : index === 0 || index === 1 ? 'none' : 'auto'
											}}
										/>
									</Typography>
									<Typography
										variant='inherit'
										color='textSecondary'
										style={{ paddingRight: index >= 2 ? '' : 'var(--pixel28)', color: (index === 0 || index === 1) ? '#B0B0B0' : '' }}
									>
										{language?.required}
									</Typography>
									{index >= 2 &&
									<Tooltip title='Delete' placement='top'>
										<Typography variant='inherit' color='textSecondary' display='flex' alignItems='center' onClick={() => toggleDelete(index)}>
											<RiDeleteBinLine fontSize='var(--pixel20)' style={{ cursor: 'pointer' }} />
										</Typography>
									</Tooltip>
									}
								</Stack>
							</Grid>
						</Grid>
					</Box>
				))}
				{registration && <Typography variant='inherit' py='var(--pixel8)' onClick={toggleAddField}>
					<Button variant='outlined' disableElevation disableRipple>
						{language?.addFileds}
					</Button>
				</Typography>}
			</Stack>
			{addField &&
			<AddCustomField
				open={addField} handleClose={toggleAddField} handleAddField={handleAddField}
			/>}
			{delPopUp.open &&
			<NewDialogPopup
				open={delPopUp.open}
				handleConfirm={toggleDelete} // for no
				closeCallBack={handleDeleteField} // for yes
				type={language?.no}
				id={undefined}
				label={language.delFiled}
				from='feedCreate'
				formatType={language?.yes}
			/>
			}
		</Grid>
	);
};

export default RegistrationField;
